export default __webpack_public_path__ + "static/knot-ec69f1d698a500c659fed9a71ffd88cb.png";